import angular, { ILogService, IPromise, ITimeoutService } from 'angular'
import { cloneDeep, filter, map } from 'lodash'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { AppConfigService } from 'src/_candidato/comun/services/app-config.service'
import { MainQuestion, MainQuestionEdit } from 'src/_candidato/data/main-question'
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore'
import { RestResponse } from 'src/_panel/comun/js--base--unimat--local'
import { IFilaCV, IListadoCV, IModelMainQuestion, IResultadoAccionCV } from 'src/model/candidato-api'
import { BaseFiltrosComponent } from '../_base/base-filtros.component'
import { FILTROS, FILTRO_DEFECTO, Filtro } from '../_base/filtros'
import './lista-ultimos-curriculums.scss'
import { tap } from 'rxjs'

class ListaUltimosCurriculumsComponentCtrl extends BaseFiltrosComponent {
  filtros!: boolean

  $loading = false

  panelcv = {
    $visible: false,
    cv: null as IFilaCV | null,
  }

  paneleditcv = {
    $visible: false,
    cv: null as IFilaCV | null,
  }

  mostrarTotal = false
  total = {
    count: 0,
    valid: false,
  }

  datosTipos: TiposDocEstadosStore

  private totalesCall: IPromise<unknown>
  private mainQCall: IPromise<unknown>
  private exited = false

  columnaMiddleMan = true

  constructor(
    private $element: JQLite,
    $log: ILogService,
    private $timeout: ITimeoutService,
    private AccesoDatos: AccesoDatos,
    appConfigService: AppConfigService
  ) {
    super($log, appConfigService)

    this.autoUnsub(
      //
      this._flags
        .pipe(
          tap((flags) => {
            this.mostrarTotal = flags.esAppCandidato

            this.columnaMiddleMan = this.usercfg && this.usercfg.adm && flags.esAppModifContratos
          })
        )
        .subscribe()
    )
  }

  $onInit(): void {
    this.$log.info('[ListaUltimosCurriculumsComponentCtrl] onInit')

    this.filtrosList = cloneDeep(FILTROS)
    this.activaFiltro(this.filtrosList[0])

    this.AccesoDatos.Datos_Client.tiposParaDocuemntos().then(
      (tiposResponse) => (this.datosTipos = new TiposDocEstadosStore(tiposResponse))
    )

    this.totalesCall = this.$timeout(() => this.actualizaTotales(), 1000)
    this.mainQCall = this.$timeout(() => this._actualizaMainQ(), 5000)
  }

  $onDestroy() {
    // this.$timeout.cancel(this.selectUpdate)

    this.mainQCall && this.$timeout.cancel(this.mainQCall)
    this.totalesCall && this.$timeout.cancel(this.totalesCall)

    this.exited = true
  }

  private actualizaTotales() {
    this.AccesoDatos.GestionCurr_CLIENT.totalCV().then((responseResumen) => {
      if (responseResumen.valid) {
        this.total.valid = true
        this.total.count = responseResumen.totalValid
      } else this.total.valid = false
    })
  }

  _actualizaMainQ() {
    if (this.exited) return

    if (!this.mainq.$load) {
      this.mainq.$load = this.AccesoDatos.MainQuestions_CLIENT.todasLasPregPrincipales()

      this.mainq.$load
        .then((responseList) => {
          // solo las que permiten búsqueda
          this.mainq.list = map(
            filter(responseList, (mq) => mq.usar_busquedas),
            (mq) => new MainQuestion(mq)
          )
        })
        .then(() => {
          // establecer el primero
          if (this.mainq.list.length) {
            this.filtroQ.mainq = this.mainq.list[0].data_mq.idmainq
          }

          this._updateSelect()
        })
    }
  }

  _busqueda() {
    // al inicio, obtener los ítems de menú disponibles, no solo los visibles
    let filtros: RestResponse<IListadoCV>
    if (this.filtros) {
      let _filtrosBusqueda = (this.filtroActivo && this.filtroActivo.filtros(this)) || cloneDeep(FILTRO_DEFECTO)

      filtros = this.AccesoDatos.GestionCurr_CLIENT.listCV(_filtrosBusqueda)
    } else filtros = this.AccesoDatos.GestionCurr_CLIENT.lastCV()

    filtros.then((listadoResponse) => {
      this.$log.info('listado', listadoResponse)
      this.listado = null
      this.listadolist = []

      this.$timeout(() => {
        this.listado = listadoResponse
        this.listadolist = listadoResponse.list
      })
    })
  }

  accesscv(idx: number) {
    if (this.listado) {
      this.$log.debug('access', this.listado.list[idx])

      this.panelcv.cv = this.listado.list[idx]
      this.panelcv.$visible = true
    } else {
      this.$log.debug('access edit, no listado', idx)
    }
  }

  accessEditcv(idx: number) {
    if (this.listado) {
      this.$log.debug('access edit', this.listado.list[idx])
      this.paneleditcv.cv = this.listado.list[idx]
      this.paneleditcv.$visible = true
    } else {
      this.$log.debug('access edit, no listado', idx)
    }
  }

  _updateSelect() {
    if (this.exited) return

    this.$timeout(() => (this.$element.find('select') as any).formSelect(), 100)
  }

  seleccionaMainQ() {
    this.$log.info('=============')
  }

  activaFiltro(f: Filtro) {
    this.filtroActivo?.onend && this.filtroActivo.onend(this)

    this.filtroActivo = f

    f.onactivate(this)
  }

  updateAccionCV(cvdata: IResultadoAccionCV) {
    this._updateAccion(cvdata, this.panelcv)
  }

  updateAccionEditCV(cvdata: IResultadoAccionCV) {
    this._updateAccion(cvdata, this.paneleditcv)
  }

  private _updateAccion(cvdata: IResultadoAccionCV, _panel: { cv: IFilaCV | null }) {
    this.$log.info(' update!!!!!!', cvdata)

    const _actualcv = _panel.cv

    if (_actualcv) {
      _actualcv.cv.estado = cvdata.actionitem.state
      _actualcv.cv.fcrevision = cvdata.actionitem.fc
    }
  }
}

angular.module('candidato').component('listaUltimosCurriculums', {
  bindings: {
    filtros: '<',
  },
  controller: ListaUltimosCurriculumsComponentCtrl,
  template: require('./lista-ultimos-curriculums.component.html'),
  // templateUrl: "lista-ultimos-curriculums.component.html",
})
